export default {
  FETCH_TOPBANNER(state, data) {
    state.topbanner.list = data
  },
  FETCH_TOPBANNER_ALL(state, data) {
    state.topbanner.all = data
  },
  SET_TOPBANNER_LOADING(state, status) {
    state.topbanner.loading = status
  },
  SET_TOPBANNER_DETAIL(state, data) {
    state.detail.data = data
  },

  SET_TOPBANNER_DETAIL_LOADING(state, status) {
    state.detail.loading = status
  }
}
